import { makeStyles } from '@material-ui/core/styles';


export default makeStyles(theme => ({
    fixloader: {
        width: '100%',
        height: '100%',
        zIndex: 44444444444444,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        position: 'fixed',
        background: '#0049a326',
        "& img": {
            position: 'relative',
            right: window.isMobileView? ''  :'8%',
            fill: window.isPadView ? 'white' : 'black',
            width: '80px',
        }
    },
    dialogloaderNoBg: {
        position: 'absolute',
        width: '100%',
        background: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 200000,
        height: '100%',
        "& img": {
            width: '65px',
        }
    },
    dialogloader: {
        position: 'absolute',
        width: '100%',
        background: '#0049a326',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 200000,
        height: '100%',
        "& img": {
            width: '65px',
        }
    }


}));